import { ModelFactory } from '@leverege/ui-plugin';
import { ns } from '@leverege/i18n';
import Unit from '@leverege/unit';
import StreamingExportFormatter from "./StreamingExportFormatter.js";
import Model from "./CSVExportFormatterModel.js";
import Util from "./Util.js";
const {
  t
} = ns('ui-attributes.export.StreamingExportFormatter');
class CSVExportFormatter extends StreamingExportFormatter {
  constructor(...rest) {
    super(...rest);
    this.headerWritten = false;
  }
  writeData(data, fields) {
    const csv = this.getCSV(data, fields);
    this.headerWritten = true;
    return this.writer.write(this.textEncoder.encode(csv));
  }
  end() {
    super.end();
    this.headerWritten = false;
  }
  onError() {
    super.onError();
    this.headerWritten = false;
  }
  getCSV(items, fields) {
    return `${this.headerWritten ? '' : this.getHeader(fields)}${this.getRows(items, fields)}`;
  }
  getHeader(fields) {
    return fields.reduce((prev, curr, index) => {
      const attribute = Util.getAttributeForField(curr);
      const model = ModelFactory.get(curr);
      const header = model.getHeaderLabel(curr) || attribute?.displayName || t('header', {
        index: index + 1
      });
      const unit = Unit.getUnit(curr?.formatter?.unit)?.displaySymbol;
      const isLast = index === fields.length - 1;
      return `${prev}${header}${unit ? ` (${unit})` : ''}${isLast ? '\n' : Model.getSeparator(this.model)}`;
    }, '\uFEFF');
  }
  getRows(items, fields) {
    return items.reduce((prev, curr) => {
      return `${prev}${this.getRow(curr, fields)}\n`;
    }, '');
  }
  getRow(item, fields) {
    return fields.reduce((prev, field, index) => {
      const isLast = index === fields.length - 1;
      const attr = Util.getAttributeForField(field);
      const model = ModelFactory.get(field);
      const value = attr.get(item.data);
      const rawValue = model.rawValue(value, field);
      return `${prev}"${rawValue}"${isLast ? '' : Model.getSeparator(this.model)}`;
    }, '');
  }
}
export default CSVExportFormatter;